<div class="main">
    <div class="container">
        <div class="assigned-attributes-header">Assigned Attributes</div>
        <div>
            <button
                mat-icon-button
                matTooltip="Edit Assigned Attributes"
                (click)="editAssignedAttributes()"
                [disabled]="!canEdit">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
    </div>

    <div class="assigned-attributes-content">
        <ul class="assigned-attributes-list">
            <li *ngFor="let attribute of assignedAttributes">
                {{ attribute.name }}
            </li>
        </ul>
    </div>

    <form [formGroup]="form" novalidate (ngSubmit)="submit()">
        <div class="consumer-type-content">
            <mat-form-field appearance="fill"   class="flex-align-center flex-55">
                <mat-select
                    placeholder="Consumer Type"
                    required
                    formControlName="destinationType"
                >
                    <mat-option
                        *ngFor="let consumerType of (consumerTypes$ | async)"
                        [value]="consumerType.tag"
                    >
                        {{ consumerType.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['destinationType'].invalid">
                    Please select a Consumer Type
                </mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="fill"   class="flex-align-center flex-55">
                <mat-label>Consumer Description</mat-label>
                <textarea
                    matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    
                    required
                    placeholder="Please enter a description"
                    formControlName="description" class="flex-100"
                ></textarea>
                <mat-error *ngIf="form.controls['description'].invalid">Please enter a Name</mat-error>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="fill"   class="flex-align-center flex-55">
                <mat-select
                    placeholder="Sales Channels"
                    multiple
                    formControlName="salesChannels">
                    <mat-option
                        *ngFor="let channel of salesChannels"
                        [value]="channel.tag"
                        [disabled]="true">
                        {{ channel.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</div>
